<template>
    <form class="container" @submit.prevent="send">
        <input class="form-control" type="email" v-model="email" required placeholder="Email" />
        <input class="form-control" type="text" v-model="subject" required placeholder="Onderwerp" />
        <textarea class="form-control" v-model="message" required></textarea>
        <button class="btn btn-outline-azure" type="submit" :disabled="isLoading">Versturen</button>
    </form>
</template>

<script>
export default {
    name: 'email',
    data() {
        return {
            isLoading: false,
            email: '',
            message: '',
            subject: ''
        }
    },
    created() {
        if(!this.$store.getters.isAuthenticated || this.$store.getters.user.name.indexOf('intelligencecompany') < 0)
        {
            return this.$router.push('/');
        }
    },
    methods: {
        send() {
            this.isLoading = true;
            this.$http.post('api/Email', { message: this.message, email: this.email, subject: this.subject }).then(() =>
            {
                this.email = '';
                this.message = '';
                this.subject = '';
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            })
        }
    }
}
</script>